'use client'
import SectionContainer from '@/components/SectionContainer'
import Navbar from '@/screens/dashboard/newUi/Navbar'
import { Skeleton } from '@mantine/core'
import { useEffect } from 'react'

const PropertyDetailsSectionSkeletonWrapper = () => {
  useEffect(() => {
    const scrollContainer = document.scrollingElement ?? document.documentElement

    scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [])

  return (
    <div>
      <Navbar loading={true} isPropertyDetailPage={true} />
      <section className='max-w-[1440px] mx-auto'>
        <SectionContainer className='md:pt-20 max-w-[1300px] w-full md:px-3 lg:p-5 max-md:p-0 md:relative max-md:overflow-x-hidden'>
          <div className='hidden md:block mb-6'>
            <Skeleton h={18} w='28%' radius='md' />
          </div>

          <div className='max-md:hidden mb-10'>
            <Skeleton h={460} className='w-full rounded-[24px]' />
          </div>

          <div className='md:hidden px-4 pt-4 space-y-5'>
            <Skeleton h={300} radius='xl' />
            <Skeleton h={320} radius='xl' />
          </div>

          <div className='md:flex justify-between max-md:gap-1 xl:gap-8 w-full'>
            <div className='max-xl:max-w-[60%] max-md:max-w-full md:flex-1 xl:flex-[60%] md:me-3'>
              <div className='hidden md:block space-y-8'>
                <Skeleton h={170} radius='xl' />
                <Skeleton h={434} radius='xl' />
                <Skeleton h={260} radius='xl' />
                <Skeleton h={420} radius='xl' />
                <Skeleton h={220} radius='xl' />
              </div>

              <div className='md:hidden px-3 py-2 space-y-6'>
                <Skeleton h={180} radius='xl' />
                <Skeleton h={350} radius='xl' />
                <Skeleton h={240} radius='xl' />
                <Skeleton h={320} radius='xl' />
              </div>
            </div>

            <div className='xl:flex-[40%] w-full hidden min-md:block z-20'>
              <Skeleton h={390} className='w-full rounded-xl' />
            </div>
          </div>

          <div className='mt-12 space-y-6'>
            <Skeleton h={28} w={220} radius='md' />
            <div className='grid grid-cols-1 md:grid-cols-3 gap-5'>
              <Skeleton h={260} radius='xl' />
              <Skeleton h={260} radius='xl' />
              <Skeleton h={260} radius='xl' />
            </div>
          </div>
        </SectionContainer>
      </section>
    </div>
  )
}

export default PropertyDetailsSectionSkeletonWrapper
